var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{attrs:{"id":"vestibular"}},[_c('Banner'),_c('Diferenciais'),_c('Video',{attrs:{"conteudo":_vm.pagina.secoes[0].conteudo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }